import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import groupBy from 'lodash/groupBy';
import { Meta } from 'common/components/meta';
import { LoadingIndicator } from 'common/components/preloader';

export default class ProductUpdates extends Component {
  constructor(props) {
    super(props);

    this.fetch = this.fetch.bind(this);
  }

  fetch() {
    const { params, fetchAll } = this.props;
    fetchAll(params.userType);
  }

  componentDidMount() {
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.params.userType !== this.props.params.userType) {
      this.fetch();
    }
  }

  renderItems() {
    const groupedByDay = groupBy(this.props.items, 'date');

    return Object.keys(groupedByDay).map(date => {
      const groupedByType = groupBy(groupedByDay[date], 'update_type');
      const types = ['new', 'improved', 'bugfix', 'removed'];

      return (
        <div className="day-group" key={date}>
          <h4>{ moment(date).format('MMMM D, YYYY') }</h4>

          { types.map(type => {
            const typeItems = groupedByType[type];

            if (!typeItems) {
              return null;
            }

            return (
              <div className="type-group" key={type}>
                <div className={classnames("tag tag-sm", type)}>{ type }</div>
                { typeItems.map(item => {
                  return (
                    <div className="item" key={item.id}>
                      <i className="fa fa-circle-thin" />
                      <div className="content"
                        dangerouslySetInnerHTML={{ __html: item.description }} />
                    </div>
                  );
                }) }
              </div>
            );
          }) }
        </div>
      );
    });
  }

  render() {
    const { isFetching, items } = this.props;

    return (
      <div className="l-content product-updates" id="content">
        <Meta title="What's New on crowdspring.com"
          meta={[{ name: "robots", content: "noindex,nofollow" }]} />

        { isFetching? <LoadingIndicator /> :
        <div className="row">
          <div className="columns small-16 large-10">
            { items.length === 0? <h3>No updates at the moment.</h3> : this.renderItems() }
          </div>
        </div> }
      </div>
    );
  }
}

ProductUpdates.propTypes = {
  params: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
}



// WEBPACK FOOTER //
// ./product_updates/components/index.jsx